import { createContext } from 'react';
import { useModal } from 'src/services/modal';

const HomeContext = createContext();

export default HomeContext;

export function HomeProvider({ children }) {
  const itemizeAssetsInfoModal = useModal();
  const ineligibleModal = useModal();

  return (
    <HomeContext.Provider value={{ itemizeAssetsInfoModal, ineligibleModal }}>
      {children}
    </HomeContext.Provider>
  );
}
